import { Component, Injector, OnInit, ViewChild } from "@angular/core";
import {
  ReceivableSummary,
  Receivable,
  ReceivableSearchRequest,
  UserTransaction,
} from "src/app/models/receivable";
import { ReceivableService } from "src/app/services/receivable.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as firebase from "firebase";
import {
  UserTransactionStatus,
  UserTransactionFilter,
} from "src/app/models/account";

declare var $: any;

@Component({
  selector: "app-list-receivable",
  templateUrl: "./list-receivable.component.html",
  styleUrls: ["./list-receivable.component.css"],
})
export class ListReceivableComponent implements OnInit {
  public summary: ReceivableSummary;
  public receivables: Receivable[] = [];
  public transactions: UserTransaction[] = [];

  public queryParam: ReceivableSearchRequest = new ReceivableSearchRequest();
  public limit = 30;
  public off = 0;
  public filter = 0;
  public status = 0;

  get getStatus() {
    return UserTransactionStatus;
  }
  get getFilter() {
    return UserTransactionFilter;
  }

  public canShowMore = false;
  public isLoadingReceivable = true;
  public isLoadingTransaction = true;
  public statusEmpty = false;
  totalTagihan = 0;
  listInvoiceSelected = [];
  message = "";
  activeTab = null;
  totalReturn = 0;

  constructor(
    public receivableService: ReceivableService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    window.scrollTo(0, 0);
    const isGT = localStorage.getItem("gtStatus");
    const isTOP = localStorage.getItem("topStatus");
    if (isGT === "true" && isTOP === "true") {
      this.router.navigate(["/dashboard"]);
    } else {
      this.route.queryParams.subscribe(params => {
        if (params['status']) {
          const status = params['status'];

          this.activeTab = "invoice";
          this.queryParam.lim = 30;
          this.queryParam.off = 0;

          if (status === 'overdue') {
            this.status = 3;
            this.queryParam.filter = 3;
          } else if (status === 'not-due') {
            this.status = 2;
            this.queryParam.filter = 2;
          } else if (status === 'due') {
            this.status = 1;
            this.queryParam.filter = 1;
          }
          this.getReceivable();
          this.getTransaction();
        } else if (params['tab']) {
          const tab = params['tab'];

          if (tab === 'payment') {
            $("ul.tabs li").removeClass("current");
            $(".tab-content").removeClass("current");

            this.activeTab = "payment"
            $("#tab-2").addClass("current");
          }
          this.getReceivable();
          this.getTransaction()
        } else {
          this.activeTab = "invoice"
          this.queryParam.lim = 30;
          this.queryParam.off = 0;
          this.queryParam.filter = 0;
          this.status = 0;
          this.getReceivable();
          this.getTransaction();
        }
      });
    }
  }

  ngOnInit() {
    firebase.analytics().logEvent("tagihan_page");

    this.applyJqueryScript();
    this.getSummary();
    this.setDefaultQueryParam();
    this.getReturnBatch();

    this.route.queryParams.subscribe(params => {
      if (params['status']) {
        const status = params['status'];

        this.activeTab = "invoice";
        this.queryParam.lim = 30;
        this.queryParam.off = 0;

        if (status === 'overdue') {
          this.status = 3;
          this.queryParam.filter = 3;
        } else if (status === 'not-due') {
          this.status = 2;
          this.queryParam.filter = 2;
        } else if (status === 'due') {
          this.status = 1;
          this.queryParam.filter = 1;
        }
        this.getReceivable();
        this.getTransaction();
      } else if (params['tab']) {
        const tab = params['tab'];

        if (tab === 'payment') {
          $("ul.tabs li").removeClass("current");
          $(".tab-content").removeClass("current");

          this.activeTab = "payment"
          $("#tab-2").addClass("current");
        }
        this.getReceivable();
        this.getTransaction()
      } else {
        this.activeTab = "invoice"
        this.queryParam.lim = 30;
        this.queryParam.off = 0;
        this.queryParam.filter = 0;
        this.status = 0;
        this.getReceivable();
        this.getTransaction();
      }
    });
  }

  applyJqueryScript(): void {
    $("ul.tabs li").click(function () {
      const tab_id = $(this).attr("data-tab");

      $("ul.tabs li").removeClass("current");
      $(".tab-content").removeClass("current");

      // console.log(this)
      $(this).addClass("current");
      $("#" + tab_id).addClass("current");
    });
  }

  setDefaultQueryParam() {
    this.route.queryParamMap.subscribe((params) => {
      this.queryParam.lim = this.limit;
      this.queryParam.off = this.off;
      this.queryParam.filter = this.status;
    });
  }

  getSummary() {
    this.summary = this.receivableService.getSummary(
      (data) => {
        this.summary = data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  checkItem(event: any) {
    const existingData = this.listInvoiceSelected.find(
      (x) => x.invoice_number === event
    );
    const idx = this.listInvoiceSelected.indexOf(existingData);
    if (idx !== -1) {
      this.listInvoiceSelected.splice(idx, 1);
      this.totalTagihan =
        this.totalTagihan > 0
          ? this.totalTagihan - existingData.credit_value
          : 0;
      return;
    }

    const add = this.receivables.find((x) => x.invoice_number === event);
    this.listInvoiceSelected.push(add);
    this.totalTagihan = this.totalTagihan + +add.credit_value;
  }

  onChangeStatusReceivable(status) {
    this.status = status;
    this.limit = 30;
    this.off = 0;
    this.setDefaultQueryParam();
    this.getReceivable();
  }

  getReceivable() {
    this.isLoadingReceivable = true;
    this.receivableService.getReceivable(
      this.queryParam,
      (data) => {
        this.receivables = data || [];

        if (this.receivables.length > 0) {
          this.off += this.limit;
          this.canShowMore = true;
        } else {
          this.canShowMore = false;
        }

        this.isLoadingReceivable = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getTransaction() {
    this.isLoadingTransaction = true;
    this.receivableService.getUserTransaction(
      this.filter,
      (data) => {
        this.transactions = data || [];
        this.transactions.forEach((item) => {
          if (item.invoiceId != null) {
            let str = item.invoiceId;
            const idx = str.length - 3;
            str = str.replace(str.substring(0, idx), "...");
            item.invoiceId = str;
          }
        });

        this.isLoadingTransaction = false;

        if (this.transactions.length === 0) {
          this.statusEmpty = true;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  toPaymentChannel() {
    const exist = this.transactions.find((x) => x.status === 0);
    if (exist) {
      this.message = "Mohon selesaikan pembayaran sebelumnya terlebih dahulu.";
      $("#notif").modal("show");
      return;
    }

    const data = btoa(JSON.stringify(this.listInvoiceSelected));
    this.router.navigate([`/receivable/payment-channel/${data}`]);
  }

  handleOKNotif() {
    $("#notif").modal("hide");
  }

  public navigateToPaymentDetail(transaction: UserTransaction): void {
    if (transaction.status === this.getStatus.Waiting) {
      this.router.navigate([
        `/receivable/process-payment/${btoa(JSON.stringify(transaction))}`,
      ]);
    } else {
      this.router.navigate([
        `/receivable/detail-payment/${btoa(JSON.stringify(transaction))}`,
      ]);
    }
  }

  showMore() {
    this.isLoadingReceivable = true;
    this.canShowMore = false;
    this.setDefaultQueryParam();

    this.receivableService.getReceivable(this.queryParam, (data) => {
      if (data.length > 0) {
        data.forEach((element) => {
          this.receivables.push(element);
        });
      }

      this.off += this.limit;
      this.isLoadingReceivable = false;

      if (data.length >= this.limit) {
        this.canShowMore = true;
      }
    }, (err) => { });
  }
  
  navigateToReturPage() {
    this.router.navigate(['/retur']);
  }

  getReturnBatch() {
    this.receivableService.getReturnBatch(
      (response) => {
        this.totalReturn = response.data;
      }, 
      (err) => {
        console.log(err);
      }
    );
  }
}
